import { PecSwitch, PrivateRoute } from 'components/route'
import { useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions.generated'
import { EquipeDetailRootView } from 'view/equipe/detail/EquipeDetailRootView'

import { UnidadeSaudeDetailView } from './UnidadeSaudeDetailView'

export interface UrlParams {
  unidadeSaudeId: string
}

export function UnidadeSaudeDetailRootView() {
  const match = useRouteMatch<UrlParams>()

  const renderUnidadeSaude = () => <UnidadeSaudeDetailView unidadeSaudeId={match.params.unidadeSaudeId} />
  const renderEquipeDetail = () => <EquipeDetailRootView unidadeSaudeId={match.params.unidadeSaudeId} />

  return (
    <PecSwitch>
      <PrivateRoute
        path={`${match.url}/equipes/:equipeId(\\d+)`}
        render={renderEquipeDetail}
        permission={Permissions.visualizarUnidadesDeSaude}
      />
      <PrivateRoute
        path={`${match.url}`}
        render={renderUnidadeSaude}
        permission={Permissions.visualizarUnidadesDeSaude}
      />
    </PecSwitch>
  )
}
